import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="container-page py-12 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4 lg:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-600">
                <span className="font-label text-lg font-semibold leading-none text-accent-400">51</span>
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-base font-bold text-foreground-950">51视频每日大赛</span>
                <span className="mt-1 font-label text-[10px] tracking-[0.3em] text-secondary-600">今日黑榜合集</span>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-foreground-600">
              每日赛事黑榜视频的精选汇总站。我们把足球、篮球、电竞、赛车与综合赛事里的关键失误按日归档，
              方便你按分类、时间段与等级快速回看。
            </p>
            <p className="mt-4 max-w-md text-xs leading-relaxed text-foreground-500">
              站内视频封面与播放界面均为演示内容，不提供真实赛事直播或下载。
            </p>
          </div>

          <div>
            <h4 className="font-label text-xs tracking-[0.24em] text-secondary-600">
              <Link to="/" className="hover:text-primary-700">站点导航</Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/" className="text-foreground-700 transition-colors hover:text-primary-700">首页</Link></li>
              <li><Link to="/search" className="text-foreground-700 transition-colors hover:text-primary-700">搜索结果</Link></li>
              <li><Link to="/about" className="text-foreground-700 transition-colors hover:text-primary-700">关于本站</Link></li>
              <li><Link to="/category/football" className="text-foreground-700 transition-colors hover:text-primary-700">足球黑榜</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-label text-xs tracking-[0.24em] text-secondary-600">
              <Link to="/category/football" className="hover:text-primary-700">赛事分类</Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/category/${category.id}`}
                    className="text-foreground-700 transition-colors hover:text-primary-700"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 51视频每日大赛今日黑榜合集 · 内容仅作赛事视频汇总演示</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>联系邮箱：contact@51daily-blame.example</span>
            <Link to="/about" className="transition-colors hover:text-primary-700">免责声明</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}